import ReactDOM from 'react-dom/client';
import App from 'views/App';
import './setupApp';

ReactDOM.createRoot(document.getElementById('root')!).render(<App />);
